import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';
import { CommonService } from '../common.service';

@Component({
  selector: 'app-client-details',
  templateUrl: './client-details.component.html',
  styleUrls: ['./client-details.component.scss']
})
export class ClientDetailsComponent implements OnInit {
  clientInfo: any = {};

  constructor(
    private dialogRef: MatDialogRef<ClientDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private commonService: CommonService,
    public sharedService: SharedService,
  ) { }

  ngOnInit(): void {
    this.getLabClient();
  }

  getLabClient() {
    this.commonService.getLabClient(this.data.clientId).subscribe(res => {
      if (res) {
        this.clientInfo = res;
      }
    });
  }

  cancelClick(): void {
    this.dialogRef.close();
  }

}
